import { BiTrash } from "react-icons/bi";
import MyOverlayTrigger from "../../common/MyOverlayTrigger";
import { useTranslation } from "react-i18next";

interface deleteButtonProps {
  deleteHandler: (e?: any) => void;
  onKeyDown?: () => void;
  tabIndex?: number;
}

const DeleteButton = ({
  deleteHandler,
  onKeyDown,
  tabIndex
}: deleteButtonProps) => {
  const { t } = useTranslation();
  return (
    <MyOverlayTrigger
      title={t("MacBotResponseForm/deleteBlock")}
      placement="top"
    >
      <div
        tabIndex={tabIndex}
        onKeyDown={() => {
          onKeyDown && onKeyDown();
        }}
        onClick={(e) => {
          deleteHandler();
        }}
        className="tw-cursor-pointer tw-p-2.5 tw-border-solid tw-bg-white tw-rounded-full tw-shadow-sm tw-border tw-border-gray-300 tw-justify-start tw-items-center tw-gap-3 tw-flex "
      >
        <BiTrash
          size={24}
          className="tw-w-6 tw-h-6 tw-relative tw-overflow-hidden"
          color="red"
        />
      </div>
    </MyOverlayTrigger>
  );
};

export default DeleteButton;
